import React from 'react';
import '../styles/MessageFab.css';

const MessageFab = ({ onClick }) => (
  <button className="msg-fab" onClick={onClick} title="Support">
    💬
  </button>
);
export default MessageFab;